import { Icon } from 'antd'
import React from 'react'
import {
    FaFileWord,
    FaFileExcel,
    FaFilePdf,
    FaFileImage,
    FaFileVideo,
    FaFileAudio,
    FaFileArchive,
    FaFileCode,
    FaFile,
    FaFilePowerpoint,
    FaFileAlt,
} from 'react-icons/fa'
import ShortsAcceptIcon from '../../../../../assets/shorts-accept-icon-1.png'
import ShortsPendingIcon from '../../../../../assets/shorts-pending-icon-1.png'
import ShortsRejectIcon from '../../../../../assets/shorts-reject-icon-2.png'

const getFileIcon = (fileType, mimeType, type, item) => {
    const isList = type === 'LIST'
    const isThumbnail = type === 'THUMBNAIL'
    const isGrid = type === 'GRID'
    let fontSize = '20px'

    if (isList) {
        fontSize = '16px' // Smaller icons for list view
    } else if (isThumbnail) {
        fontSize = '24px'
    } else if (isGrid) {
        fontSize = '32px' // Larger icons for grid view
    } else {
        fontSize = '60px'
    }
    // Use colored icons for thumbnails with proper styling, colored for other contexts
    const getThumbnailIconColor = (fileType, mimeType) => {
        if (mimeType) {
            switch (mimeType) {
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                case 'application/rtf':
                case 'application/msword':
                    return '#4A90E2' // Microsoft Word blue
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                case 'application/vnd.ms-excel':
                    return '#217346' // Microsoft Excel green
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                case 'application/vnd.ms-powerpoint':
                    return '#D24726' // Microsoft PowerPoint red
                case 'application/pdf':
                    return '#FF4444' // PDF red
                default:
                    break
            }
        }

        switch (fileType) {
            case 'FOLDER':
                return '#FFD700' // Gold for folders
            case 'IMAGE':
            case 'PEXEL_IMAGE':
            case 'GIF':
            case 'ARIMAGE':
            case 'CERT':
            case 'BADGE':
                return '#4CAF50' // Green for images
            case 'VIDEO':
            case 'VIDEO_STREAM':
            case 'VIDEO_ANTMEDIA':
                return '#FF5722' // Orange for videos
            case 'AUDIO':
            case 'PODCAST':
                return 'rgba(255, 255, 255, 0.9)' // White for audio (better contrast on dark)
            case 'ARCHIVE':
            case 'ZIP':
                return '#FF9800' // Orange for archives
            case 'CODE':
                return '#00BCD4' // Cyan for code
            case 'TEXT':
                return '#607D8B' // Blue grey for text files
            default:
                return '#607D8B' // Blue grey for default
        }
    }

    // Handle different contexts with appropriate colors
    let iconColor
    if (isThumbnail) {
        iconColor = getThumbnailIconColor(fileType, mimeType)
    } else if (isGrid) {
        // Use colored icons for grid view (similar to regular view but with grid size)
        if (mimeType) {
            switch (mimeType) {
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                case 'application/msword':
                case 'application/rtf':
                    iconColor = '#2b579a' // Word blue
                    break
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                case 'application/vnd.ms-excel':
                    iconColor = '#217346' // Excel green
                    break
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                case 'application/vnd.ms-powerpoint':
                    iconColor = '#D24726' // PowerPoint red
                    break
                case 'application/pdf':
                    iconColor = '#d4414c' // PDF red
                    break
                default:
                    iconColor = undefined
            }
        } else {
            switch (fileType) {
                case 'FOLDER':
                    iconColor = '#1890ff' // Blue for folders
                    break
                case 'IMAGE':
                case 'PEXEL_IMAGE':
                case 'GIF':
                case 'ARIMAGE':
                case 'CERT':
                case 'BADGE':
                    iconColor = '#52c41a' // Green for images
                    break
                case 'VIDEO':
                case 'VIDEO_STREAM':
                case 'VIDEO_ANTMEDIA':
                    iconColor = '#1890ff' // Blue for videos
                    break
                case 'AUDIO':
                case 'PODCAST':
                    iconColor = '#1890ff' // Blue for audio
                    break
                case 'ARCHIVE':
                case 'ZIP':
                    iconColor = '#fa8c16' // Orange for archives
                    break
                case 'CODE':
                    iconColor = '#13c2c2' // Cyan for code
                    break
                case 'TEXT':
                    iconColor = '#607D8B' // Blue grey for text files
                    break
                default:
                    iconColor = undefined
            }
        }
    } else if (isList) {
        // Use subtle but visible colors for list view
        if (mimeType) {
            switch (mimeType) {
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                case 'application/msword':
                case 'application/rtf':
                    iconColor = '#2b579a' // Word blue
                    break
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                case 'application/vnd.ms-excel':
                    iconColor = '#217346' // Excel green
                    break
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                case 'application/vnd.ms-powerpoint':
                    iconColor = '#D24726' // PowerPoint red
                    break
                case 'application/pdf':
                    iconColor = '#d4414c' // PDF red
                    break
                default:
                    iconColor = '#666'
            }
        } else {
            switch (fileType) {
                case 'FOLDER':
                    iconColor = '#1890ff' // Blue for folders
                    break
                case 'IMAGE':
                case 'PEXEL_IMAGE':
                case 'GIF':
                case 'ARIMAGE':
                case 'CERT':
                case 'BADGE':
                    iconColor = '#52c41a' // Green for images
                    break
                case 'VIDEO':
                case 'VIDEO_STREAM':
                case 'VIDEO_ANTMEDIA':
                    iconColor = '#1890ff' // Blue for videos
                    break
                case 'AUDIO':
                case 'PODCAST':
                    iconColor = '#1890ff' // Blue for audio
                    break
                case 'ARCHIVE':
                case 'ZIP':
                    iconColor = '#fa8c16' // Orange for archives
                    break
                case 'CODE':
                    iconColor = '#13c2c2' // Cyan for code
                    break
                case 'TEXT':
                    iconColor = '#607D8B' // Blue grey for text files
                    break
                default:
                    iconColor = '#666' // Gray for default
            }
        }
    } else {
        // For regular view (white background), use appropriate colors
        if (mimeType) {
            switch (mimeType) {
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                case 'application/msword':
                case 'application/rtf':
                    iconColor = '#2b579a' // Darker blue for white background
                    break
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                case 'application/vnd.ms-excel':
                    iconColor = '#217346' // Excel green
                    break
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                case 'application/vnd.ms-powerpoint':
                    iconColor = '#D24726' // PowerPoint red
                    break
                case 'application/pdf':
                    iconColor = '#d4414c' // PDF red
                    break
                default:
                    iconColor = undefined
            }
        } else {
            switch (fileType) {
                case 'FOLDER':
                    iconColor = '#1890ff' // Blue for folders
                    break
                case 'IMAGE':
                case 'PEXEL_IMAGE':
                case 'GIF':
                case 'ARIMAGE':
                case 'CERT':
                case 'BADGE':
                    iconColor = '#52c41a' // Green for images
                    break
                case 'VIDEO':
                case 'VIDEO_STREAM':
                case 'VIDEO_ANTMEDIA':
                    iconColor = '#1890ff' // Blue for videos
                    break
                case 'AUDIO':
                case 'PODCAST':
                    iconColor = '#1890ff' // Blue for audio (good contrast on white)
                    break
                case 'ARCHIVE':
                case 'ZIP':
                    iconColor = '#fa8c16' // Orange for archives
                    break
                case 'CODE':
                    iconColor = '#13c2c2' // Cyan for code
                    break
                case 'TEXT':
                    iconColor = '#607D8B' // Blue grey for text files
                    break
                default:
                    iconColor = undefined
            }
        }
    }

    if (mimeType) {
        switch (mimeType) {
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            case 'application/msword':
            case 'application/rtf':
                return <FaFileWord style={{ color: iconColor, fontSize: fontSize }} />
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            case 'application/vnd.ms-excel':
                return (
                    <FaFileExcel style={{ color: iconColor, fontSize: fontSize }} />
                )
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            case 'application/vnd.ms-powerpoint':
                return (
                    <FaFilePowerpoint style={{ color: iconColor, fontSize: fontSize }} />
                )
            case 'application/pdf':
                return <FaFilePdf style={{ color: iconColor, fontSize: fontSize }} />
            default:
                break
        }
    }

    switch (fileType) {
        case 'FOLDER':
            return (
                <Icon
                    type="folder"
                    style={{ color: iconColor, fontSize: fontSize }}
                />
            )
        case 'IMAGE':
        case 'PEXEL_IMAGE':
        case 'GIF':
        case 'ARIMAGE':
        case 'CERT':
        case 'BADGE':
            return <FaFileImage style={{ color: iconColor, fontSize: fontSize }} />

        case 'VIDEO':
        case 'VIDEO_STREAM':
        case 'VIDEO_ANTMEDIA':
            if (item && item.category === "tips" && item.tip && item.tip.status) {
                let iconSrc;

                if (item.tip.status === "approved") {
                    iconSrc = ShortsAcceptIcon;
                } else if (item.tip.status === "rejected") {
                    iconSrc = ShortsRejectIcon;
                } else if (item.tip.status === "pending") {
                    iconSrc = ShortsPendingIcon;
                }

                if (iconSrc) {
                    return (
                        <img
                            src={iconSrc}
                            alt="Tips icon"
                            style={{
                                width: isGrid ? "32px" : "40px",
                                height: isGrid ? "32px" : "40px",
                                objectFit: 'contain'
                            }}
                        />
                    );
                }
            }

            return <FaFileVideo style={{ color: iconColor, fontSize: fontSize }} />;

        case 'AUDIO':
        case 'PODCAST':
            return (
                <Icon type="sound" style={{ color: iconColor, fontSize: fontSize }} />
            )

        case 'APPLICATION':
            if (mimeType && mimeType.includes('document')) {
                return <FaFileWord style={{ color: iconColor, fontSize: fontSize }} />
            } else if (mimeType && mimeType.includes('sheet')) {
                return (
                    <FaFileExcel style={{ color: iconColor, fontSize: fontSize }} />
                )
            } else if (mimeType && mimeType.includes('pdf')) {
                return <FaFilePdf style={{ color: iconColor, fontSize: fontSize }} />
            }
            return <FaFile style={{ color: iconColor, fontSize: fontSize }} />

        case 'ARCHIVE':
        case 'ZIP':
            return (
                <FaFileArchive style={{ color: iconColor, fontSize: fontSize }} />
            )

        case 'CODE':
            return <FaFileCode style={{ color: iconColor, fontSize: fontSize }} />
        case 'TEXT':
            return <FaFileAlt style={{ color: iconColor, fontSize: fontSize }} />

        default:
            return <FaFile style={{ color: iconColor, fontSize: fontSize }} />
    }
}
export default getFileIcon
